import { useEffect } from 'react';

import { emitTpaStreamAccountConnectionAbandoned } from 'services/tpaStreamAnalytics';

/**
 * Best-effort abandonment tracking while the end user is in the TPA connect route tree.
 * Fires on SPA unmount (navigation away) and on tab/window close via pagehide.
 */
export function useTpaStreamAnalyticsAbandonment(): void {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const onPageHide = () => {
      emitTpaStreamAccountConnectionAbandoned();
    };

    window.addEventListener('pagehide', onPageHide);

    return () => {
      window.removeEventListener('pagehide', onPageHide);
      emitTpaStreamAccountConnectionAbandoned();
    };
  }, []);
}
